import { AxiosError } from 'axios';
import showNotification from 'utils/showNotification';
import { axiosAPI } from 'lib/api';
import { logInfo } from 'utils/logging';
import { getCSRFTOKEN } from 'utils/cookie/getCSRFToken';

type postNewAnswerResponse = {
  success: boolean;
};

const postNewAnswer = async (
  questionId: string,
  body: string,
): Promise<postNewAnswerResponse> => {
  const csrf_token = getCSRFTOKEN('OTVETY-CSRF-TOKEN') || '';
  try {
    return await axiosAPI({
      url: `/otvety/api/answers`,
      method: 'POST',
      headers: {
        'X-CSRF-TOKEN': csrf_token,
      },
      data: {
        question_id: questionId,
        body,
      },
    });
  } catch (error) {
    const e = error as AxiosError;
    showNotification('error', 'Произошла ошибка, повтори попытку позже');
    logInfo(e.toString(), true);
    return { success: false };
  }
};

export default postNewAnswer;
